import React, { useState, forwardRef, ForwardedRef } from "react";
import { Form } from "react-bootstrap";
import { utils } from "utils/Utils";
import { SiteData } from "../Data/SiteData";
interface FontFileUploadProps {
  id: string; 
  className?: string; 
  onUpload: (files: File[]) => void; 
  setLoading: (loading: boolean) => void;
  siteData?: SiteData;
}

const FontFileUpload = forwardRef(({
  id, 
  className, 
  onUpload, 
  setLoading, 
  siteData
}: FontFileUploadProps, ref: ForwardedRef<HTMLInputElement>) => {

  const validExtensions = [".woff2", ".woff", ".ttf", ".otf"]

  const handleFileClick = (e: React.MouseEvent<HTMLInputElement>) => {
    (e.target as HTMLInputElement).value = "";
  };

  const isValidFontFile = (file: File): boolean => {

    if (!file) return false;
    if (file.size === 0) return false;

    const lastDotIndex = file.name.lastIndexOf(".");
    if(lastDotIndex === -1) return false;
    
    const fileExt = file.name.substring(lastDotIndex).toLowerCase();
    const fileName = file.name.substring(0, lastDotIndex);

    if (siteData?.siteStyling.customFonts) {
      for (const fontStr of siteData?.siteStyling.customFonts) {
         try {
          const fontData = JSON.parse(fontStr);
          if (fontData && fontData.family === fileName) {
            utils.ShowAlert("Duplicate Font", `A font named "${fileName}" already exists.`, "OpenDialog2");
            return false;
          }
         } catch (error) {
          continue; 
         }
      }
    }
    return validExtensions.includes(fileExt);
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const element = e.target as HTMLElement;
    const parent = element.parentElement?.parentElement;
    if (parent) parent.classList.remove('over');

    const files = e.target.files ? Array.from(e.target.files) : [];
    if(files.length === 0) return; 
    setLoading(true);

    // Filter valid files
    const validFiles = files.filter(isValidFontFile);
    
    if (validFiles.length > 0) {
      onUpload(validFiles);
    } else {
      setLoading(false);
      utils.ShowAlert("Invalid File Type", "Please upload valid font files (.ttf, .otf, .woff, or .woff2)", "OpenDialog2");
    }
  }

  const handleDragEnter = (e: React.DragEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const element = e.target as HTMLElement;
    const parent = element.parentElement?.parentElement;
    if (parent) parent.classList.add('over');
  }

  const handleDragLeave = (e: React.DragEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const element = e.target as HTMLElement;
    const parent = element.parentElement?.parentElement;
    if (parent) parent.classList.remove('over');
  }
  

  return (
    <div>
      <Form.Control
        type="file"
        multiple
        className={`uploadfile-control ${className || ""}`}
        id={id}
        accept=".ttf, .otf, .woff, .woff2"
        onClick={handleFileClick}
        onChange={handleFileChange}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        ref={ref}
      />
    </div>
  )
});

export default FontFileUpload;